import React from "react";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import styles from "./style.module.css";
export default class Button extends React.PureComponent {
    render() {
        const { className, type, disabled, isSmall, isDark, isBackwardsDark, isThinText, active, onClick, isLoading, isTransparentLoading, loadingText, greyscaleDefaultState, activeBold, ...retProps } = this.props;
        const retIsDisabled = disabled || isLoading || isTransparentLoading;
        let buttonClass = styles.button;
        switch (String(type).toUpperCase()) {
            case "PRIMARY":
                buttonClass += " " + styles.primary;
                break;
            case "GREY":
            case "GRAY":
                buttonClass += " " + styles.grey;
                break;
            case "PURPLE":
                buttonClass += " " + styles.purple;
                break;
            case "PLAIN":
                buttonClass += " " + styles.purple;
                break;
            case "PURPLE2":
                buttonClass += " " + styles.purpleTwo;
                break;
            case "TRANSPARENT":
                buttonClass += " " + styles.transparent;
                break;
            case "LIGHTPURPLE":
                buttonClass += " " + styles.lightPurple;
                break;
            case "SECONDARY":
            default:
                buttonClass += " " + styles.secondary;
                break;
        }
        if (isSmall) {
            buttonClass += " " + styles.smallButton;
        }
        if (active) {
            buttonClass += " " + styles.active;
        }
        if (retIsDisabled) {
            buttonClass += " " + styles.disabled;
        }
        if (isTransparentLoading) {
            buttonClass += " " + styles.transparentLoading;
        }
        if (isThinText) {
            buttonClass += " " + styles.thinText;
        }
        if (greyscaleDefaultState) {
            buttonClass += " " + styles.greyscaleDefaultState;
        }
        if (activeBold) {
            buttonClass += " " + styles.activeBold;
        }
        if (className) {
            buttonClass += " " + className;
        }
        return (React.createElement("button", { ...retProps, onClick: onClick && !retIsDisabled ? onClick : undefined, className: (isDark ? styles.darkMode : isBackwardsDark ? styles.bDarkMode : "") + " " + buttonClass }, isLoading || isTransparentLoading ? (React.createElement(React.Fragment, null,
            React.createElement(LoadingIndicator, { style: {
                    width: "20px",
                    height: "18px",
                    transform: loadingText ? "scale(0.4)" : isSmall ? "scale(0.20)" : "scale(0.40)",
                    margin: loadingText ? "-10px 24px 10px -5px" : isSmall ? "-5px 5px 5px -5px" : "-10px 5px 10px -5px"
                } }),
            loadingText ? loadingText : React.createElement(React.Fragment, null))) : (this.props.children)));
    }
}
